import React from 'react'
import style from "./block.module.scss";
import dayjs from 'dayjs';

function ArticleInfo({postTitle, postCategory, datePublication}){
    return  <div className={style.block}>
                <div className={style.container}>
                    <div className={style.category}>{postCategory && postCategory}</div>                    
                    <div className={style.date}>{datePublication && dayjs(datePublication).format("LL")}</div>
                </div>
            </div>
}

export default ArticleInfo;
